import React, {Component, Fragment} from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import {RESOURCES as reportsResources} from '../fuseInventoryOrdersResourceMap';
import {
    addCommas,
    convertDate,
    getTodayOffsetHour,
    toCurrency,
    sortCurrency
} from '../shared/functions';
import {postInventoryOrderData} from '../shared/inventoryOrderFunctions';
import {getGetHeaders} from '../shared/serverFunctions';
import {getTableState, setDefaultTableSort, filterCaseInsensitive} from '../shared/tableFunctions';
import DialogInventoryOrderConfirm from './DialogInventoryOrderConfirm';
import ViewButtonByCustomRoute from '../buttons/ViewButtonByCustomRoute';
import Config from '../messages';
import FuseTheme from '../global/theme';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';

/**
 * Inventory Orders class for retrieving and displaying summary
 */
class InventoryOrdersTable extends Component {
    constructor(props) {
        super(props);

        const offsetHour = getTodayOffsetHour();

        this.state = {
            confirmOrderData: null,
            confirmOrderOpen: false,
            confirmOrderType: 'submit',
            error: false,
            loading: false,
            message: null,
            offsetHour: offsetHour,
            summaryComplete: false,
            summaryList: [],
            summaryTableData: [],
            summaryTotal: 0,
            tableLimit: 10000,
            tableOffset: 0,
            tablePage: 0,
            tableSort: {id: 'name', desc: false}
        };

        this.fetchInventoryOrdersData = this.fetchInventoryOrdersData.bind(this);
    }

    componentWillMount() {
        this.fetchInventoryOrdersData();
    }

    fetchInventoryOrdersData() {
        this.setState({
            loading: true
        });
        let params = {
            limit: this.state.tableLimit,
            offset: this.state.tableOffset,
            search: this.state.reportSearch,
            sort: this.state.tableSort
        };

        let resource = reportsResources.InventoryOrder.GET_LIST(params);

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data) {
                this.processInventoryOrdersData(result.data.locations);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + 'Inventory Orders.';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + 'Inventory Orders: ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Inventory Orders Error: ', error.message);
            }
            this.setState({
                error: true,
                loading: false,
                message: message,
                summaryList: [],
                summaryTableData: [],
                summaryComplete: true,
                summaryTotal: 0
            });
        });
    }

    processInventoryOrdersData = (locations) => {
        let summaryList = [];
        let summaryTotal = (locations) ? locations.length : 0;
        for (let i = 0; i < summaryTotal; i++) {
            let job = locations[i];
            if (job && job.job_id) {
                job.location_id = job.cs_location;
                // Set totals
                job.categoriesTotal = (job.categories) ? addCommas(job.categories) : '0';
                job.productsTotal = (job.products) ? addCommas(job.products) : '0';
                job.productsOverriddenTotal = (job.products_overridden) ? addCommas(job.products_overridden) : '0';
                // Set currency values
                job.forecastedValue = (job.forecasted_value) ? addCommas(job.forecasted_value, false) : toCurrency(0);
                job.onHandValue = (job.on_hand_value) ? addCommas(job.on_hand_value, false) : toCurrency(0);
                job.requestedValue = (job.requested_value) ? addCommas(job.requested_value, false) : toCurrency(0);
                // Add date strings
                job.job_created_sort = convertDate(job.job_created, 'query-with-time', true);
                job.job_created_str = convertDate(job.job_created, 'display', true, true, this.state.offsetHour, true);
                job.latest_override_sort = convertDate(job.latest_override, 'query-with-time', true);
                job.latest_override_str = new Date(job.latest_override).toLocaleString();

                summaryList.push(job);
            }
        }

        this.setState({
            error: false,
            loading: false,
            message: null,
            summaryList: summaryList,
            summaryTableData: summaryList,
            summaryComplete: true,
            summaryTotal: summaryTotal
        });
    };

    processPostInventoryData = (type, params, response) => {
        let error = false;
        let message = '';
        if (response.data && response.data.message && response.data.message.includes('success')) {
            message = 'Success';
            switch (type) {
                case 'location-submit':
                    message = 'This Location Order has been generated.';
                    break;
                case 'location-delete':
                    message = 'This Location Order has been deleted.';
                    break;
                default:
                    message = 'Success';
                    break;
            }
        } else if (response.error) {
            error = true;
            switch (type) {
                case 'location-submit':
                    message = 'Sorry, there was an error generating this Location Order.';
                    break;
                case 'location-delete':
                    message = 'Sorry, this Location order could not be deleted.';
                    break;
                default:
                    message = 'Sorry, there was an error';
                    break;
            }
        }
        this.setState({
            error: error,
            loading: false,
            message: message,
        }, () => {
            setTimeout(() => {
                this.fetchInventoryOrdersData();
            }, 1000);
        });
    };

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleLocationSubmit = (data) => {
        this.setState({
            error: false,
            message: null,
            confirmOrderOpen: false,
            confirmOrderType: null,
            loading: true
        }, () => {
            let params = {
                job_id: data.job_id,
                location_id: data.location_id
            };
            postInventoryOrderData('location-submit', params)
                .then((result) => {
                    this.processPostInventoryData(result.type, result.params, result.data);
                })
                .catch(error => {
                    this.processPostInventoryData(error.type, error.params, error.data);
                });
        });
    };

    handleLocationDelete = (data) => {
        this.setState({
            error: false,
            message: null,
            confirmOrderOpen: false,
            confirmOrderType: null,
            loading: true
        }, () => {
            let params = {
                job_id: data.job_id,
                location_id: data.location_id
            };
            postInventoryOrderData('location-delete', params)
                .then((result) => {
                    this.processPostInventoryData(result.type, result.params, result.data);
                })
                .catch(error => {
                    this.processPostInventoryData(error.type, error.params, error.data);
                });
        });
    };

    handleConfirmOrderOpen = (action, data) => {
        this.setState({
            confirmOrderData: data,
            confirmOrderOpen: true,
            confirmOrderType: action
        });
    };

    handleDialogClose = (dialog) => {
        if (dialog === 'order') {
            this.setState({
                confirmOrderData: null,
                confirmOrderOpen: false,
                confirmOrderType: null
            });
        }
    };

    render() {
        const {
            confirmOrderData,
            confirmOrderOpen,
            confirmOrderType,
            error,
            loading,
            message,
            summaryComplete,
            summaryList
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'cs_location', order: 'ASC'});

        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: '',
                        id: 'Inventory-Order-View',
                        Cell: row => (
                            <span>
                                <ViewButtonByCustomRoute
                                    customPath={`${row.original.job_id}/${row.original.cs_location}`}
                                    basePath="/InventoryOrder"
                                />
                            </span>
                        ),
                        filterable: false,
                        sortable: false,
                        width: 60
                    },
                ]
            },
            {
                Header: 'Job and Location',
                columns: [
                    {
                        Header: 'Job Name',
                        accessor: 'job_name',
                        style: tableStyles.wrapText
                    },
                    {
                        Header: 'Location',
                        accessor: 'cs_location',
                        width: 90,
                        style: tableStyles.right
                    }
                ]
            },
            {
                Header: 'Products',
                columns: [
                    {
                        Header: 'Products',
                        accessor: 'products',
                        width: 90,
                        filterable: false,
                        Cell: (row) => <span>{row.original.productsTotal}</span>,
                        style: tableStyles.right
                    },
                    {
                        Header: () => (<span>Products<br/>Overridden</span>),
                        accessor: 'products_overridden',
                        width: 100,
                        filterable: false,
                        Cell: (row) => <span>{row.original.productsOverriddenTotal}</span>,
                        style: tableStyles.right
                    },
                    {
                        Header: 'Categories',
                        accessor: 'categories',
                        width: 96,
                        filterable: false,
                        Cell: (row) => <span>{row.original.categoriesTotal}</span>,
                        style: tableStyles.right
                    }
                ]
            },
            {
                Header: 'Values',
                columns: [
                    {
                        Header: 'Forecasted',
                        accessor: 'forecastedValue',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: () => (<span>On Hand /<br/>In Transit</span>),
                        accessor: 'onHandValue',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: () => 'Requested',
                        accessor: 'requestedValue',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    }
                ]
            },
            {
                Header: '',
                columns: [
                    {
                        Header: 'Created',
                        accessor: 'job_created',
                        filterable: false,
                        Cell: (row) => <span>{row.original.job_created_str}</span>
                    },
                    {
                        Header: 'Created by',
                        accessor: 'job_user',
                        style: tableStyles.noWrapText
                    }
                ]
            },
            {
                Header: '',
                columns: [
                    {
                        Header: '',
                        id: 'Inventory-Order-Buttons',
                        Cell: row => (
                            <span>
                                <RaisedButton
                                    size="small"
                                    style={{...tableStyles.tableBtnMedium, ...tableStyles.tableBtnInline}}
                                    buttonStyle={tableStyles.tableBtnStyle}
                                    label="Approve All"
                                    labelStyle={tableStyles.tableBtnLabel}
                                    labelColor={FuseTheme.palette.accent2Color}
                                    backgroundColor={FuseTheme.palette.primary1Color}
                                    onClick={() => this.handleConfirmOrderOpen('submit', row.original)}
                                />
                                <RaisedButton
                                    size="small"
                                    style={{...tableStyles.tableBtn, ...tableStyles.tableBtnInline}}
                                    buttonStyle={tableStyles.tableBtnStyle}
                                    label="Delete"
                                    labelStyle={tableStyles.tableBtnLabel}
                                    labelColor={FuseTheme.palette.accent2Color}
                                    backgroundColor={FuseTheme.palette.accent1Color}
                                    onClick={() => this.handleConfirmOrderOpen('delete', row.original)}
                                />
                            </span>
                        ),
                        filterable: false,
                        sortable: false,
                        width: 234
                    },
                ]
            }
        ];

        return (
            <div>

                {!summaryComplete && !error &&
                    <div className="loader-container">
                        <h4>Retrieving Inventory Orders...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }
                {message &&
                    <div className={(error) ? 'error' : ''}>
                        <p>{message}</p>
                    </div>
                }

                {summaryComplete &&
                    <div className="reports-table-container">

                        {/* Table Header: Inventory Orders */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container report-header-button-container">
                                <FlatButton
                                    label="Refresh"
                                    labelStyle={{color: "#FFFFFF"}}
                                    icon={<RefreshIcon color="#FFFFFF"/>}
                                    onClick={() => this.fetchInventoryOrdersData()}
                                />
                            </div>
                            <h3 className="table-table-header-title">
                                <span>Inventory Orders</span>
                            </h3>
                        </div>

                        {/* Table: Inventory Orders */}
                        <ReactTable
                            key="table-inventory-orders"
                            data={summaryList}
                            columns={tableColumns}
                            defaultPageSize={10000}
                            showPagination={false}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            loading={loading}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, this.inventoryOrderReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.inventoryOrderReactTable)}
                            ref={(r) => this.inventoryOrderReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped"
                        />
                    </div>
                }

                {/* Dialog: Submit/Delete Order Confirmation */}
                <Dialog
                    modal={false}
                    open={confirmOrderOpen}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                >
                    {summaryComplete &&
                        <Fragment>
                            {confirmOrderType === 'submit' &&
                                <DialogInventoryOrderConfirm
                                    data={confirmOrderData}
                                    type="order"
                                    action="submit"
                                    onSubmit={() => this.handleLocationSubmit(confirmOrderData)}
                                    onCancel={() => this.handleDialogClose('order')}
                                />
                            }
                            {confirmOrderType === 'delete' &&
                                <DialogInventoryOrderConfirm
                                    data={confirmOrderData}
                                    type="order"
                                    action="delete"
                                    onSubmit={() => this.handleLocationDelete(confirmOrderData)}
                                    onCancel={() => this.handleDialogClose('order')}
                                />
                            }
                        </Fragment>
                    }
                </Dialog>
            </div>
        )
    }
}

export default InventoryOrdersTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryOrdersTable.js